import EventEmitter from "events";

const emitLocal = new EventEmitter();

 export default emitLocal;